module.exports = __webpack_public_path__ + "static/images/cover_D2.21f4e34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_D2.png
// module id = vIgV
// module chunks = 8